export default __webpack_public_path__ + "fonts/demographics_highest_education_level_icon.svg";